import React, { ReactElement, PropsWithChildren, ReactNode } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'
import { ErrorBox } from 'components/LoginSignUpForm'

export function TitleSection({
  error,
  isLoading = false,
  subTitle,
  children,
  sxSubTitle,
  sxTitle,
}: PropsWithChildren<{
  error?: string | ReactNode
  isLoading?: boolean
  subTitle?: string
  sxSubTitle?: ThemeUIStyleObject
  sxTitle?: ThemeUIStyleObject
}>): ReactElement {
  return (
    <Flex sx={{ flexDirection: 'column', alignItems: 'center' }}>
      <Text
        as="h1"
        data-testid="page-title"
        sx={{
          fontSize: '4rem',
          fontWeight: 600,
          color: 'aliceBlue',
          ...sxTitle,
        }}
        tabIndex={0}
      >
        {children}
      </Text>
      {subTitle && (
        <Text
          sx={{
            maxWidth: ['100%', '54rem'],
            fontSize: '1.6rem',
            fontWeight: 400,
            color: 'lightSteelBlue',
            lineHeight: '140%',
            mt: '1.6rem',
            ...sxSubTitle,
          }}
          tabIndex={0}
        >
          {subTitle}
        </Text>
      )}
      <ErrorBox
        errorMessage={error}
        isLoading={isLoading}
        sx={{
          minHeight: '3.5rem',
          fontSize: '1.5rem',
          my: ['0.8rem', '2.4rem'],
          maxWidth: ['100%', '48rem'],
          textAlign: 'center',
        }}
      />
    </Flex>
  )
}
